import * as React from 'react';
import '../css/loader.sass';

interface LoaderProps {
  loaderText?: string;
}

export default function Loader({
  loaderText = 'Processing, please wait'
}: LoaderProps) {
  return (
    <section className="cf-loader">
      <div className="cf-loader__lockup">
        <div className="cf-loader__icon-container">
          <div className="cf-loader__icon">
            <div className="cf-loader__circle" id="loader-circle-1"></div>
            <div className="cf-loader__circle" id="loader-circle-2"></div>
            <div className="cf-loader__circle" id="loader-circle-3"></div>
            <div className="cf-loader__circle" id="loader-circle-4"></div>
          </div>
        </div>
        <p>{loaderText}</p>
      </div>
    </section>
  );
}
